import api from '../utils/api';

const ClaimActions = {
  convert(listingAlias) {
    return (dispatch) =>
      dispatch(api.users.properties.feedToManual.convert(listingAlias))
        .then((result) => {
          if (!result.success) {
            return Promise.reject(result.error.message);
          }
          return Promise.resolve(result.response);
        })
        .catch((err) => Promise.reject(err.message));
  },
};

export default ClaimActions;
